import { getType } from 'deox';
import { Middleware } from 'redux';

import { impersonationActions } from 'src/store/impersonation/actions';
import { persister } from 'src/utils/persister/persister';

import { uiActions } from './actions';

export const uiPersisterMiddleware: Middleware = (store) => (next) => (action) => {
  const res = next(action);

  switch (action.type) {
    case getType(uiActions.setServerGroupsOpen):
    case getType(uiActions.setTableItemsPerPage):
    case getType(uiActions.toggleOnboardingCard):
      persister.set({ key: 'ui', item: store.getState().ui, isPerUser: true });
      break;
    case getType(impersonationActions.stopImpersonating):
      persister.clear({ key: 'ui', isPerUser: true });
  }

  return res;
};
